import React, { useEffect, useState } from 'react'
import PortafolioItem from '../elements/PortafolioItem'

const PortafolioSection = () => {
  const [filter, setFilter] = useState('All');
  const [repoData, setRepoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch('/metadatainfo.json');
        const data = await response.json();
        setRepoData(data);
      } catch (err) {
        setError('Failed to fetch repository data.');
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  const renderRepoData = () => {
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const filteredProjects = Object.values(repoData).filter((project) => {
      if (filter === 'All') return true;
      return project.category === filter;
    });

    if (!filteredProjects || filteredProjects.length === 0) return <p className='text-center'>Proyectos no encontrados...</p>;

    return filteredProjects.map((project, index) => (
      <PortafolioItem
        key={project.title}
        type={project.category}
        name={project.title}
        img={project.images[0]}
        description={project.subtitle}
      />
    ));
  };

  const filterButtons = () => {
    const filters = ["All", "App Web", "ERP"];
    return (
      <>
        {filters.map((value) => (
          <li key={value} data-filter={value}>
            <button
              className={`btn ${filter === value ? "filter-active" : ""}`}
              onClick={() => setFilter(value)}
            >
              {value}
            </button>
          </li>
        ))}
      </>
    );
  };

  return (
    <section id="portfolio" className="portfolio section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Portafolio</h2>
        <p>
          Tenemos diferentes soluciones y diseños para satisfacer las necesidades de nuestros clientes,
          puedes ver algunos de nuestros proyectos en la galeria
        </p>
      </div>
      <div className="container">
        <div className="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">
          <ul className="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
            {filterButtons()}
          </ul>
          <div className="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200">
            {renderRepoData()}
          </div>
        </div>
      </div>
    </section>
  )
}

export default PortafolioSection